import React, { useState, useEffect, useRef } from 'react';
import { workingProcess } from '../../data/mock';

const WorkingProcessSection = () => {
  const [activeStep, setActiveStep] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('active');
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll('.reveal, .reveal-scale');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 reveal">
          <span className="inline-block px-4 py-1.5 bg-[#ff6b35]/10 text-[#ff6b35] text-sm font-semibold rounded-full mb-4">
            Our Process
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How We Work
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A proven methodology that delivers results on time, every time.
          </p>
        </div>

        {/* Process Timeline */}
        <div className="reveal-scale">
          {/* Desktop Steps */}
          <div className="hidden lg:flex items-start justify-between mb-12">
            {workingProcess.map((step, index) => (
              <div
                key={index}
                className="flex-1 relative cursor-pointer"
                onClick={() => setActiveStep(index)}
              >
                {/* Connector Line */}
                {index < workingProcess.length - 1 && (
                  <div className={`absolute top-6 left-1/2 w-full h-0.5 ${
                    index < activeStep ? 'bg-[#ff6b35]' : 'bg-gray-200'
                  }`}></div>
                )}
                
                {/* Step Circle */}
                <div className="relative flex flex-col items-center">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg z-10 transition-all duration-300 ${
                    index <= activeStep 
                      ? 'bg-[#ff6b35] text-white shadow-lg shadow-[#ff6b35]/30' 
                      : 'bg-gray-100 text-gray-400'
                  }`}>
                    {step.step}
                  </div>
                  <h4 className={`mt-4 font-semibold text-center transition-colors ${
                    index === activeStep ? 'text-[#ff6b35]' : 'text-gray-700'
                  }`}>
                    {step.title}
                  </h4>
                </div>
              </div>
            ))}
          </div>

          {/* Active Step Content */}
          <div className="bg-gray-50 rounded-3xl p-8 lg:p-12">
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#ff6b35] text-white font-bold text-2xl mb-6">
                {workingProcess[activeStep].step}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {workingProcess[activeStep].title}
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed">
                {workingProcess[activeStep].description}
              </p>
            </div>

            {/* Mobile Step Dots */}
            <div className="flex justify-center gap-2 mt-8 lg:hidden">
              {workingProcess.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveStep(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === activeStep ? 'bg-[#ff6b35] w-6' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkingProcessSection;
